export default "/images/vendor/quill/icons/header-2.svg?34914793e4453a1d65d78b933b421fce";